import React from "react";
import { Link, useLocation } from "react-router-dom";
import { 
  LayoutDashboard, 
  Users, 
  Building2, 
  Settings, 
  LogOut, 
  ShieldCheck,
  Activity
} from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import "./admin.css";

const AdminSidebar = () => {
  const location = useLocation();
  const { logout } = useAuth();

  const menuItems = [
    { icon: <LayoutDashboard size={18} strokeWidth={2.5} />, label: "OVERVIEW", path: "/dashboard/admin" },
    { icon: <Users size={18} strokeWidth={2.5} />, label: "STAFF_REGISTRY", path: "/dashboard/admin/doctors" },
    { icon: <Activity size={18} strokeWidth={2.5} />, label: "PATIENT_REGISTRY", path: "/dashboard/admin/patients" },
    { icon: <Building2 size={18} strokeWidth={2.5} />, label: "PARTNER_NETWORK", path: "/dashboard/admin/hospitals" },
    { icon: <Settings size={18} strokeWidth={2.5} />, label: "SYSTEM_CONFIG", path: "/dashboard/admin/settings" },
  ];

  return (
    <aside className="admin-sidebar">
      <div className="brand-logo-section">
        <div className="brand-logo">
          <ShieldCheck size={24} className="icon-blue" strokeWidth={2.5} />
        </div>
        <div className="brand-info">
          <span className="brand-name">Medico.in</span>
          <span className="brand-tag">SYS_OVERSIGHT</span>
        </div>
      </div>

      <nav className="sidebar-nav">
        {menuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`nav-item ${location.pathname === item.path ? "active" : ""}`}
          >
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-label">{item.label}</span>
          </Link>
        ))}
      </nav>

      <div className="sidebar-footer" style={{ marginTop: 'auto', paddingTop: '2rem', borderTop: '1px solid rgba(59, 130, 246, 0.1)' }}>
        <button 
          className="nav-item" 
          onClick={logout} 
          style={{ width: '100%', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--admin-text-dim)' }}
        >
          <span className="nav-icon"><LogOut size={18} strokeWidth={2.5} /></span>
          <span className="nav-label">DE_AUTHORIZE</span>
        </button>
      </div>
    </aside>
  );
};

export default AdminSidebar;
